import React, { ReactNode } from 'react'
import StyledContent from './styles'

const Content: React.FC<{ children: ReactNode }> = ({ children }, ...props) => {
  return <StyledContent {...props}>{children}</StyledContent>
}

export default Content
